import React from 'react'
import { navigate } from 'gatsby'
import Link from '../components/link'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import * as R from 'ramda'
import Layout from '../components/layout'
import HeaderHome from '../components/header-home'
import Hero from '../components/hero'
import CategoryHome from '../components/category-home'
import UpcomingBox from '../components/upcoming-box'
import FavoriteHome from '../components/favorite-home'
import NewsHome from '../components/news-home'
import PrivilegeList from '../components/privilege-list'
import BirthdayHome from '../components/birthday-home'
import PackageBanner from '../components/package-banner'
import {
  getCategoryList,
  getWisdomInfo,
  getSeasonalPrivilegeList,
  getBirthdayHomeImage,
  getPackageMe,
  getBannerPackage,
  saveStatusModalPackage,
  getTermAndCondition,
  getNewsDetail,
  acceptTermAndCondition,
  checkTermAndCondition
} from '../services'

import { SearchIcon, UserIcon } from '../components/icons'
import { openLoading, setCategory, setGroupInfo } from '../state/action'

import exception from '../handlers/global-exception'
import { ga4 } from '../handlers/google-analytic'
import { getGG } from '../state/store'

import { Modal, Checkbox, Typography, Button } from "antd";
import Image from '../components/image';
import ImagePlaceholder from '../images/birthday-home-placeholder.png';
import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons'

const { Text, Title } = Typography;

// message

const setGaViewAll = (name, params) => () => {
  const { user } = getGG().store.getState()
  ga4.gtag('event', name, {
    ...params,
    profile_id: user.profileId,
  })
}

const gaTrackSearch = profileId => {
  ga4.gtag('event', 'home_search', {
    category: 'home_search',
    profile_id: profileId,
  })
}

class IndexPage extends React.Component {
  state = {
    privileges: [],
    upcomingBooking: null,
    favorites: [],
    news: [],
    seasonalPrivileges: [],
    isBirthday: false,
    birthdayImage: '',
    birthdayTitle: '',
    birthdayNewsCode: '',
    isShowPackageSelectVisible: false,
    modalPackageSelectImg: '',
    newsCodePackageSelect: '',
    autoAssignPackage: false,
    modalPackageAutoAssignImg: '',
    packageLevelUp: false,
    isShowPopUpSelectPackage: false,
    isNotEligible: false,
    isNotShowBannerPackage: false,
    modalPackageEligibleImg: '',
    modalPackageAutoAssignTitle: '',
    modalPackageAutoAssignContent: '',
    modalPackageLevelUpTitle: '',
    modalPackageLevelUpContent: '',
    modalShowPopUpSelectPackageImage: '',
    modalShowPopUpSelectPackageTitle: '',
    modalShowPopUpSelectPackageContent: '',
    modalPackageEligibleTitle: '',
    modalPackageEligibleContent: '',
    newsCodePackageEligible: '',
    localStorageKey: '',
    isLocalStorageKey: false,
    statusModalCheckboxModalSplash: false,
    newsCodeModalSplash: '',
    termAndConditionTitle: '',
    termAndConditionContent: '',
    isTermModalVisible: false,
    isCheckedTerm: false,
    isCheckboxVisible: false,
    isCancelTermAndConditionModalVisible: false,
    isSuccessTermAndConditionModalVisible: false,
    isFalseTermAndConditionModalVisible: false,
    isDeepLink: false,
    deepLinkType: '',
    deepLinkInfo: '',
    isShowNewsPopup: false,
    newsInfoImage: '',
    newsInfoTitle: '',
    newsInfoContent: '',
    isCloseAllModal: false
  }

  modalContentRef = React.createRef();

  // [HACKY-FIX-WHITE-SCREEN] Fix white screen when press back after select seasonal privilege
  componentDidMount() {
    let savedTimestamp = sessionStorage.getItem('keyLocalStorage');

    if (!savedTimestamp) {
      savedTimestamp = new Date().toISOString();
      sessionStorage.setItem('keyLocalStorage', savedTimestamp);
      this.setState({
        isLocalStorageKey: true,
      });
    }

    this.setState({
      timestamp: savedTimestamp,
    });

    setTimeout(() => {
      const rootElement = document.documentElement
      rootElement.scrollTo({
        top: 100,
      })
      rootElement.scrollTo({
        top: 0,
      })
    }, 200)

    this.checkScrollStatus();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      (prevState.termAndConditionContent !== this.state.termAndConditionContent ||
       prevState.isTermModalVisible !== this.state.isTermModalVisible) &&
      this.state.isTermModalVisible
    ) {
      this.checkScrollStatus();
    }
  }

  fetchData = async () => {

    const { openLoading, setCategory, setGroupInfo, t } = this.props

    const searchParams = new URLSearchParams(window.location.search);

    // const product = searchParams.get('product');
    // const productGroup = searchParams.get('productGroup');
    // const packageParam = searchParams.get('package');
    // const deeplinkLocation = searchParams.get('deeplink');

    // if (product) {
    //   checkTermAndCondition()
    //     .then((result) => {
    //       if(result?.havePackage && !(result?.isAcceptTerms)){
    //         this.setState({ isDeepLink: true, deepLinkType: 'Product', deepLinkInfo: product, isShowNewsPopup: true, newsInfoImage: result.newsInfo.image, newsInfoTitle: result.newsInfo.title, newsInfoContent: result.newsInfo.content });
    //       }else{
    //         navigate('/privilege-detail/', { state: { privilegeCode: product } });
    //       }
    //     })
    //     .catch((err) => {
    //       this.setState({ isCloseAllModal: true });
    //       exception(err, this.props.t);
    //     })
    // }else if(packageParam){
    //   checkTermAndCondition()
    //     .then((result) => {
    //       if(result?.havePackage && !(result?.isAcceptTerms)){
    //         this.setState({ isDeepLink: true, deepLinkType: 'Package', deepLinkInfo: packageParam, isShowNewsPopup: true, newsInfoImage: result.newsInfo.image, newsInfoTitle: result.newsInfo.title, newsInfoContent: result.newsInfo.content });
    //       }else{
    //         navigate('/package/package-list');
    //       }
    //     })
    //     .catch((err) => {
    //       this.setState({ isCloseAllModal: true });
    //       exception(err, this.props.t);
    //     })
    // }else if(productGroup){
    //   checkTermAndCondition()
    //     .then((result) => {
    //       if(result?.havePackage && !(result?.isAcceptTerms)){
    //         this.setState({ isDeepLink: true, deepLinkType: 'ProductGroup', deepLinkInfo: productGroup, isShowNewsPopup: true, newsInfoImage: result.newsInfo.image, newsInfoTitle: result.newsInfo.title, newsInfoContent: result.newsInfo.content });
    //       }else{
    //         navigate('/package/privilege-group-list', { state: { privilegeCode: productGroup } });
    //       }
    //     })
    //     .catch((err) => {
    //       this.setState({ isCloseAllModal: true });
    //       exception(err, this.props.t);
    //     })
    // }else if(deeplinkLocation){
    //   const search = window.location.search.substring(1);
    //   const deeplinkParams = search.length > 0 ?
    //     JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) => { return key === "" ? value : decodeURIComponent(value) }) : {}

    //   checkTermAndCondition()
    //     .then((result) => {
    //       if(result?.havePackage && !(result?.isAcceptTerms)){
    //         this.setState({ isDeepLink: true, deepLinkType: 'Deeplink', deepLinkInfo: deeplinkLocation, isShowNewsPopup: true, newsInfoImage: result.newsInfo.image, newsInfoTitle: result.newsInfo.title, newsInfoContent: result.newsInfo.content });
    //       }else{
    //         navigate(`/${deeplinkLocation}`, { state: { ...deeplinkParams } });
    //       }
    //     })
    //     .catch((err) => {
    //       this.setState({ isCloseAllModal: true });
    //       exception(err, this.props.t);
    //     })
    // }

    const params = {
      product: searchParams.get('product'),
      productGroup: searchParams.get('productGroup'),
      packageParam: searchParams.get('package'),
      deeplinkLocation: searchParams.get('deeplink')
    };

    const search = window.location.search.substring(1);
    const deeplinkParams = search.length > 0
      ? JSON.parse(
          '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}',
          (key, value) => (key === "" ? value : decodeURIComponent(value))
        )
      : {};
    const paramKey = Object.keys(params).find((key) => params[key]);

    if (paramKey) {
      checkTermAndCondition()
        .then((result) => {
          if (result?.havePackage && !result?.isAcceptTerms) {
            this.setState({
              isDeepLink: true,
              deepLinkType: paramKey,
              deepLinkInfo: params[paramKey],
              isShowNewsPopup: true,
              newsInfoImage: result.newsInfo.image,
              newsInfoTitle: result.newsInfo.title,
              newsInfoContent: result.newsInfo.content
            });
          } else {
            const navigationMap = {
              product: () => navigate('/privilege-detail/', { state: { privilegeCode: params.product } }),
              packageParam: () => navigate('/package/package-list'),
              productGroup: () => navigate('/package/privilege-group-list', { state: { privilegeCode: params.productGroup } }),
              deeplinkLocation: () => navigate(`/${params.deeplinkLocation}`, { state: { ...deeplinkParams } })
            };
            if (navigationMap[paramKey]) {
              navigationMap[paramKey]();
            }
          }
        })
        .catch((err) => {
          this.setState({ isCloseAllModal: true });
          exception(err, this.props.t);
        });
    }else{
      try {
        const [
          category,
          { highlights, upcomingBooking, favourites, news, isBirthday, group },
          seasonalPrivileges,
        ] = await Promise.all([
          getCategoryList(),
          getWisdomInfo(),
          getSeasonalPrivilegeList(),
        ])
        const birthdayHome = isBirthday ? await getBirthdayHomeImage() : []
        const birthdayImage =
          isBirthday && birthdayHome.image ? birthdayHome.image : ''
        const birthdayTitle =
          isBirthday && birthdayHome.title ? birthdayHome.title : ''
        const birthdayNewsCode =
          isBirthday && birthdayHome.newsCode ? birthdayHome.newsCode : ''
        const packageMe = await getPackageMe()
        const packageInfo = packageMe.packageInfo
        let bannerPackageImage
        let isPackage = false
        let packageName = ""
        if(packageInfo && Object.keys(packageInfo).length > 0){
          isPackage = true
          packageName = packageInfo.packageName
        }else{
          bannerPackageImage = (await getBannerPackage()) || "";
        }
  
        let isShowPackageSelectVisible = false;
        let modalPackageSelectImg = '';
        let newsCodePackageSelect = '';
        let autoAssignPackage = false;
        let modalPackageAutoAssignImg = '';
        let packageLevelUp = false;
        let isShowPopUpSelectPackage = false;
        let modalShowPopUpSelectPackageImage = '';
        let modalShowPopUpSelectPackageTitle = '';
        let modalShowPopUpSelectPackageContent = '';
        let isNotEligible = false;
        let isNotShowBannerPackage = false;
        let modalPackageEligibleImg = '';
        let modalPackageAutoAssignTitle = '';
        let modalPackageAutoAssignContent = '';
        let modalPackageLevelUpTitle = '';
        let modalPackageLevelUpContent = '';
        let modalPackageEligibleTitle = '';
        let modalPackageEligibleContent = '';
        let newsCodePackageEligible = '';
        if(!this.state.isShowNewsPopup && !this.state.isCloseAllModal){
          if(packageMe.isShowPackageSelect && (packageMe.showPackageSelect && Object.keys(packageMe.showPackageSelect).length > 0)){
            isShowPackageSelectVisible = true;
            modalPackageSelectImg = packageMe.showPackageSelect.image;
            newsCodePackageSelect = packageMe.showPackageSelect.newsCode;
          }
          if(packageMe.autoAssignPackage && (packageMe.autoAssignPackageInfo && Object.keys(packageMe.autoAssignPackageInfo).length > 0)){
            autoAssignPackage = true;
            modalPackageAutoAssignImg = packageMe.autoAssignPackageInfo.image;
            modalPackageAutoAssignTitle = packageMe.autoAssignPackageInfo.title;
            modalPackageAutoAssignContent = packageMe.autoAssignPackageInfo.content;
          }
          if(packageMe.hasChangePackageLevelUp && (packageMe.changePackageLevelUpInfo && Object.keys(packageMe.changePackageLevelUpInfo).length > 0)){
            packageLevelUp = true;
            modalPackageLevelUpTitle = packageMe.changePackageLevelUpInfo.title;
            modalPackageLevelUpContent = packageMe.changePackageLevelUpInfo.content;
          }
          if(packageMe.isShowPopUpSelectPackage && (packageMe.popUpSelectPackageInfo && Object.keys(packageMe.popUpSelectPackageInfo).length > 0)){
            isShowPopUpSelectPackage = true;
            modalShowPopUpSelectPackageImage = packageMe.popUpSelectPackageInfo.image;
            modalShowPopUpSelectPackageTitle = packageMe.popUpSelectPackageInfo.title;
            modalShowPopUpSelectPackageContent = packageMe.popUpSelectPackageInfo.content;
          }
          if(packageMe.isNotEligible){
            // isNotShowBannerPackage = true;
            if(packageMe.packageNotEligibleNewsInfo && Object.keys(packageMe.packageNotEligibleNewsInfo).length > 0){
              isNotEligible = true;
              modalPackageEligibleImg = packageMe.packageNotEligibleNewsInfo.image;
              modalPackageEligibleTitle = packageMe.packageNotEligibleNewsInfo.title;
              modalPackageEligibleContent = packageMe.packageNotEligibleNewsInfo.content;
              newsCodePackageEligible = packageMe.packageNotEligibleNewsInfo.newsCode;
            }    
          }
          if(bannerPackageImage == "" || packageMe.isNotEligible){
            isNotShowBannerPackage = true;
          }
        }
  
        this.setState({
          upcomingBooking,
          privileges: highlights,
          news,
          favorites: favourites,
          seasonalPrivileges: seasonalPrivileges.data,
          initSuccess: true,
          isBirthday,
          birthdayImage,
          birthdayTitle,
          birthdayNewsCode,
          isPackage,
          packageName,
          bannerPackageImage,
          isShowPackageSelectVisible,
          modalPackageSelectImg,
          newsCodePackageSelect,
          autoAssignPackage,
          modalPackageAutoAssignImg,
          packageLevelUp,
          isShowPopUpSelectPackage,
          modalShowPopUpSelectPackageImage,
          modalShowPopUpSelectPackageTitle,
          modalShowPopUpSelectPackageContent,
          isNotEligible,
          isNotShowBannerPackage,
          modalPackageEligibleImg,
          modalPackageAutoAssignTitle,
          modalPackageAutoAssignContent,
          modalPackageLevelUpTitle,
          modalPackageLevelUpContent,
          modalPackageEligibleTitle,
          modalPackageEligibleContent,
          newsCodePackageEligible
        })
    
  
        setCategory(category)
        setGroupInfo(group)
        openLoading(false)
      } catch (err) {
  
        exception(err, t)
      }
    }
  }

  selectCategory = selectedCategory => {
    navigate('/privileges/', {
      state: {
        selectedCategory,
      },
    })
    ga4.gtag('event', 'My Privilege', {
      [`MyPrivilege_Category`]: selectedCategory.label,
    })
  }

  onChangeCheckBoxNotShowModal = async(e, newsCode) => {
    // const { t } = this.props;

    const statusModalCheckbox = e.target.checked;
    this.setState({
      statusModalCheckboxModalSplash: statusModalCheckbox,
      newsCodeModalSplash: newsCode
    });
    // if (statusModalCheckbox) {
    //   try {
    //     const saveStatusModal = await saveStatusModalPackage(newsCode);
    //     if(saveStatusModal){
    //       setTimeout(() => {
    //         if(typeModal == 'PackageSelect'){
    //           this.setState({ isShowPackageSelectVisible: false });
    //         }else{
    //           this.setState({ isNotEligible: false });
    //         }
    //       }, 250);
    //     }else{
    //       throw new Error('Save status modal package select failed.');
    //     }
    //   } catch (err) {
    //     if(typeModal == 'PackageSelect'){
    //       this.setState({ isShowPackageSelectVisible: false });
    //     }else{
    //       this.setState({ isNotEligible: false });
    //     }
    //     exception(err, t);
    //   }
    // }
  };

  closeModalSplash = async(typeModalSplash) => {
    const { t } = this.props;
    const { statusModalCheckboxModalSplash,  newsCodeModalSplash } = this.state;
    if (statusModalCheckboxModalSplash) {
      try {
        const saveStatusModal = await saveStatusModalPackage(newsCodeModalSplash);
        if(saveStatusModal){
          setTimeout(() => {
            if(typeModalSplash == 'PackageSelect'){
              this.setState({ isShowPackageSelectVisible: false });
            }else{
              this.setState({ isNotEligible: false });
            }
          }, 250);
        }else{
          throw new Error('Save status modal package select failed.');
        }
      } catch (err) {
        if(typeModalSplash == 'PackageSelect'){
          this.setState({ isShowPackageSelectVisible: false });
        }else{
          this.setState({ isNotEligible: false });
        }
        exception(err, t);
      }
    } else {
      if(typeModalSplash == 'PackageSelect'){
        this.setState({ isShowPackageSelectVisible: false });
      }else{
        this.setState({ isNotEligible: false });
      }
    }
  };

  termAndConditionFrom = async () => {
    try {
      const termAndConditionCode = await getTermAndCondition();
      let newState = {
        termAndConditionTitle: '',
        termAndConditionContent: '',
      };
  
      if (termAndConditionCode) {
        try {
          const termAndConditionData = await getNewsDetail(termAndConditionCode);
          newState = {
            termAndConditionTitle: termAndConditionData.title,
            termAndConditionContent: termAndConditionData.content,
          };
        } catch {}
      }
  
      this.setState(
        {
          ...newState,
          isTermModalVisible: true,
          autoAssignPackage: false,
          isShowPopUpSelectPackage: false,
          isShowNewsPopup: false
        },
        () => {
          if (newState.termAndConditionTitle) {
            this.checkScrollStatus();
          }
        }
      );
    } catch {
      this.setState({
        termAndConditionTitle: '',
        termAndConditionContent: '',
        isTermModalVisible: true,
        autoAssignPackage: false,
        isShowPopUpSelectPackage: false,
        isShowNewsPopup: false
      });
    }
  };

  handleTermModalCancel = () => {
    this.modalContentRef.current.scrollTop = 0;
    this.setState({ isTermModalVisible: false, isCheckboxVisible: false, isCheckedTerm: false, isCancelTermAndConditionModalVisible: true });
  };

  handleTermModalOk = () => {
    acceptTermAndCondition()
      .then((result) => {
        if(result){
          this.setState({ isTermModalVisible: false, isSuccessTermAndConditionModalVisible: true });
        }else{
          this.setState({ isTermModalVisible: false, isFalseTermAndConditionModalVisible: true });
        }
      })
      .catch((err) => {
        this.setState({ isTermModalVisible: false, isFalseTermAndConditionModalVisible: true });
      })
  };

  handleCheckboxChange = (e) => {
    this.setState({ isCheckedTerm: e.target.checked });
  };

  checkScrollStatus = () => {
    // ใช้ requestAnimationFrame แทน setTimeout เพื่อให้แน่ใจว่า DOM พร้อม
    requestAnimationFrame(() => {
      const modalContent = this.modalContentRef.current;
      if (modalContent) {
        const { scrollHeight, clientHeight } = modalContent;
        
        if (scrollHeight <= clientHeight) {
          this.setState({ isCheckboxVisible: true });
        }
      }
    });
  };

  checkIfScrollBottom = () => {
    const modalContent = this.modalContentRef.current;
    if (modalContent) {
      const { scrollTop, scrollHeight, clientHeight } = modalContent;
      if (scrollTop + clientHeight >= scrollHeight - 10) {
        this.setState({ isCheckboxVisible: true });
      }
    }
  };

  closeLiff = () => {
    const { liff = {} } = window
    if (liff.closeWindow) {
      liff.closeWindow()
    }
  };

  handleDeepLinkNavigation = () => {
    if(this.state.deepLinkType == 'packageParam'){
      navigate('/package/package-list');
    }else if(this.state.deepLinkType == 'productGroup'){
      navigate('/package/privilege-group-list', { state: { privilegeCode: this.state.deepLinkInfo } });
    }else if(this.state.deepLinkType == 'product'){
      navigate('/privilege-detail/', { state: { privilegeCode: this.state.deepLinkInfo } });
    }else if(this.state.deepLinkType == 'deeplinkLocation'){
      const search = window.location.search.substring(1);
      const deeplinkParams = search.length > 0 ?
        JSON.parse('{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}', (key, value) => { return key === "" ? value : decodeURIComponent(value) }) : {}
      navigate(`/${this.state.deepLinkInfo}`, { state: { ...deeplinkParams } });
    }
  };

  render() {
    const { t } = this.props;
    const { 
      isLocalStorageKey, 
      isTermModalVisible, 
      isCheckedTerm, 
      termAndConditionTitle, 
      termAndConditionContent, 
      isCheckboxVisible, 
      isCancelTermAndConditionModalVisible, 
      isSuccessTermAndConditionModalVisible, 
      isFalseTermAndConditionModalVisible 
    } = this.state;
    return (
      <Layout onInitSuccess={() => this.fetchData(1)}>
        {
          <>
            <HeaderHome />
            <Link className={'wisdom-home-my-status'} to={'/status'}>
              <UserIcon />
              <span className={'label'}>{t('home_status_button')}</span>
            </Link>
            <div
              className={'header-search'}
              onClick={() => gaTrackSearch(this.props.profileId)}
              button_id="search_result_by_PrivilegeName_btn"
            >
              <Link to={'/privilege-search'} state={{ value: 'Home' }}>
                <SearchIcon />
              </Link>
            </div>
            <div id={'hero-index-page'}>
              <Hero
                autoplay
                images={R.map(item => item)(this.state.privileges.slice(0, 5))}
              />
            </div>
            <Modal
              visible={this.state.isShowNewsPopup}
              footer={null}
              centered
              closable={false}
              maskClosable={false}
              onCancel={() => this.setState({ isShowNewsPopup: false })}
              className='package-modal-auto-assign-and-eligible'
            >
              <Image
                src={ this.state.newsInfoImage }
                placeholder={ ImagePlaceholder }
                alt="Image Modal Show Popup Select Package"
              />
              <div className='package-modal-auto-assign-and-eligible-body'>
                <Title level={4} className='package-modal-auto-assign-eligible-body-header'><div dangerouslySetInnerHTML={{ __html: this.state.newsInfoTitle }}></div></Title>
                <div style={{ marginTop: "24px" }} dangerouslySetInnerHTML={{ __html: this.state.newsInfoContent }}></div>
                <Button type="primary" className='button-my-package' onClick={this.termAndConditionFrom}>
                  {t('package_continue_text')}
                </Button>
              </div>
            </Modal>
            {this.state.isBirthday ? (
              <BirthdayHome
                birthdayImage={this.state.birthdayImage}
                birthdayTitle={this.state.birthdayTitle}
                birthdayNewsCode={this.state.birthdayNewsCode}
              />
            ) : null}
            {!this.state.isNotShowBannerPackage ? (
              <PackageBanner
                  bannerPackageImage={this.state.bannerPackageImage}
                  isPackage={this.state.isPackage}
                  packageName={this.state.packageName}
                  birthdayTitle={this.state.birthdayTitle}
                  birthdayNewsCode={this.state.birthdayNewsCode}
              />
            ) : null}
            {isLocalStorageKey ? (
              <>
                <Modal
                  visible={this.state.isShowPackageSelectVisible}
                  footer={null}
                  centered
                  closable={true}
                  maskClosable={false}
                  // onCancel={() => this.setState({ isShowPackageSelectVisible: false })}
                  onCancel={() => this.closeModalSplash('PackageSelect')}
                  className='package-modal-show-package-select'
                >
                  <Link to={'/package/package-list'}>
                    <Image
                      src={ this.state.modalPackageSelectImg }
                      placeholder={ ImagePlaceholder }
                      alt="Image Modal Show Package Select"
                      className='package-img-show-package-select'
                    />
                  </Link>
                  <Checkbox onChange={(e) => this.onChangeCheckBoxNotShowModal(e, this.state.newsCodePackageSelect)} className='package-modal-select-package-checkbox'><Text style={{ color: "#FFFFFF" }}>{t('package_do_not_want_to_see_this')}</Text></Checkbox>
                </Modal>

                {/* <Modal
                  visible={this.state.autoAssignPackage}
                  footer={null}
                  centered
                  closable={true}
                  maskClosable={false}
                  onCancel={() => this.setState({ autoAssignPackage: false })}
                  className='package-modal-auto-assign-and-eligible'
                >
                  <Image
                    src={ this.state.modalPackageAutoAssignImg }
                    placeholder={ ImagePlaceholder }
                    alt="Image Modal Auto Assign"
                  />
                  <div className='package-modal-auto-assign-and-eligible-body'>
                    <Title level={4} className='package-modal-auto-assign-eligible-body-header'>{ this.state.modalPackageAutoAssignTitle }</Title>
                    <div style={{ marginTop: "24px" }} dangerouslySetInnerHTML={{ __html: this.state.modalPackageAutoAssignContent }}></div>
                    <Link to={'/package/privilege-list'}>
                      <Button type="primary" className='button-my-package'>
                        {t('package_my_package')}
                      </Button>
                    </Link>
                  </div>
                </Modal> */}

                <Modal
                  visible={this.state.autoAssignPackage}
                  footer={null}
                  centered
                  closable={false}
                  maskClosable={false}
                  onCancel={() => this.setState({ autoAssignPackage: false })}
                  className='package-modal-auto-assign-and-eligible'
                >
                  <Image
                    src={ this.state.modalPackageAutoAssignImg }
                    placeholder={ ImagePlaceholder }
                    alt="Image Modal Auto Assign"
                  />
                  <div className='package-modal-auto-assign-and-eligible-body'>
                    <Title level={4} className='package-modal-auto-assign-eligible-body-header'>{ this.state.modalPackageAutoAssignTitle }</Title>
                    <div style={{ marginTop: "24px" }} dangerouslySetInnerHTML={{ __html: this.state.modalPackageAutoAssignContent }}></div>
                    <Button type="primary" className='button-my-package' onClick={this.termAndConditionFrom}>
                      {t('package_continue_text')}
                    </Button>
                  </div>
                </Modal>

                <Modal
                  visible={this.state.packageLevelUp}
                  width={300}
                  footer={null}
                  centered
                  closable={true}
                  maskClosable={false}
                  onCancel={() => this.setState({ packageLevelUp: false })}
                  className='package-modal-level-up'
                >
                  <div className={'modal-custom-body'} style={{ padding: "12px", textAlign: "center" }}>
                    <Title level={3} className={'modal-packge-title'}>
                      { this.state.modalPackageLevelUpTitle }
                    </Title>
                    <div style={{ fontSize: "16px", marginTop: "24px" }} dangerouslySetInnerHTML={{ __html: this.state.modalPackageLevelUpContent }}></div>
                    <Link to={'/package/privilege-list'}>
                      <Button type="primary" className='button-my-package'>
                        MY PACKAGE
                      </Button>
                    </Link>
                  </div>
                </Modal>

                <Modal
                  visible={this.state.isShowPopUpSelectPackage}
                  footer={null}
                  centered
                  closable={false}
                  maskClosable={false}
                  onCancel={() => this.setState({ isShowPopUpSelectPackage: false })}
                  className='package-modal-auto-assign-and-eligible'
                >
                  <Image
                    src={ this.state.modalShowPopUpSelectPackageImage }
                    placeholder={ ImagePlaceholder }
                    alt="Image Modal Show Popup Select Package"
                  />
                  <div className='package-modal-auto-assign-and-eligible-body'>
                    <Title level={4} className='package-modal-auto-assign-eligible-body-header'><div dangerouslySetInnerHTML={{ __html: this.state.modalShowPopUpSelectPackageTitle }}></div></Title>
                    <div style={{ marginTop: "24px" }} dangerouslySetInnerHTML={{ __html: this.state.modalShowPopUpSelectPackageContent }}></div>
                    <Button type="primary" className='button-my-package' onClick={this.termAndConditionFrom}>
                      {t('package_continue_text')}
                    </Button>
                  </div>
                </Modal>

                <Modal
                  visible={this.state.isNotEligible}
                  footer={null}
                  centered
                  closable={true}
                  maskClosable={false}
                  // onCancel={() => this.setState({ isNotEligible: false })}
                  onCancel={() => this.closeModalSplash('Eligible')}
                  className='package-modal-auto-assign-and-eligible'
                >
                  <Image
                    src={ this.state.modalPackageEligibleImg }
                    placeholder={ ImagePlaceholder }
                    alt="Image Modal Auto Assign"
                  />
                  <div className='package-modal-auto-assign-and-eligible-body'>
                    <Title level={4} className='package-modal-auto-assign-eligible-body-header'>{ this.state.modalPackageEligibleTitle }</Title>
                    <div style={{ marginTop: "24px" }} dangerouslySetInnerHTML={{ __html: this.state.modalPackageEligibleContent }}></div>
                    <Link to={'/status'}>
                      <Button type="primary" className='button-my-package'>
                        STATUS
                      </Button>
                    </Link>
                  </div>
                  <Checkbox onChange={(e) => this.onChangeCheckBoxNotShowModal(e, this.state.newsCodePackageEligible)} className='package-modal-not-eligible-checkbox'><Text style={{ color: "#FFFFFF" }}>{t('package_do_not_want_to_see_this')}</Text></Checkbox>
                </Modal>
              </>
            ) : null}


            <Modal
              visible={isTermModalVisible}
              icon={<span />}
              width="85%"
              closable={false}
              className="package-modal-term"
              centered
              onCancel={this.handleTermModalCancel}
              okText={t('package_list_accept')}
              cancelText={t('package_list_decline')}
              okButtonProps={{ disabled: !isCheckedTerm }}
              onOk={this.handleTermModalOk}
            >
              <div className="modal-custom-body">
                <Title level={3} className="package-font-family-sukhumvit modal-packge-term-header">
                  {termAndConditionTitle}
                </Title>
                <div
                  ref={this.modalContentRef}
                  className='package-modal-term-and-condition-content'
                  onScroll={this.checkIfScrollBottom}
                >
                  <div dangerouslySetInnerHTML={{ __html: termAndConditionContent }}></div>
                </div>
                {isCheckboxVisible && (
                  <Checkbox onChange={this.handleCheckboxChange} className='package-modal-term-and-condition-checkbox'>
                    {t('package_accept_terms_and_conditions')}
                  </Checkbox>
                )}
              </div>
            </Modal>

            <Modal
              visible={isCancelTermAndConditionModalVisible}
              icon={<span />}
              className="confirm-reject-terms-modal"
              width="350px"
              closable={false}
              centered
              footer={null}
              onCancel={() => this.setState({ isCancelTermAndConditionModalVisible: false, isTermModalVisible: true })}
            >
              <div className="modal-custom-body">
                <Title level={3} className={'modal-custom-title'}>
                  ไม่ยอมรับข้อกำหนดและเงื่อนไข​
                </Title>
                <div>กรุณายอมรับข้อกำหนดและเงื่อนไขเพื่อใช้งานสิทธิพิเศษ​</div>
                <div className="modal-custom-actions">
                  <Button className='modal-custom-actions-bt-cancel' onClick={() => this.setState({ isCancelTermAndConditionModalVisible: false, isTermModalVisible: true })}>
                    อ่านเงื่อนไข​
                  </Button>
                  <Button className='modal-custom-actions-bt-confirm' type="primary" onClick={this.closeLiff}>
                    ไม่ยอมรับเงื่อนไข​
                  </Button>
                </div>
              </div>
            </Modal>

            <Modal
              visible={isSuccessTermAndConditionModalVisible}
              width={300}
              footer={null}
              closable={false}
              centered
            >
              <div className={'modal-success-term-and-condition-body package-font-family-giovanni-and-sukhumvit'}>
                <div className={'modal-package-icon'}><CheckCircleOutlined /></div>
                <Title level={3} className={'modal-packge-title'}>
                  {t('success_label')}
                </Title>
                <div className='modal-package-detail'>
                  {this.state.isDeepLink ? 
                    <>เริ่มใช้สิทธิ์ได้ทันที​</>
                    : 
                    <>{t('package_modal_success_term_and_condition')}</>
                  }
                </div>
                {this.state.isDeepLink ? 
                  <Button type="primary" className="button-my-package" onClick={this.handleDeepLinkNavigation}>
                    อ่านรายละเอียด
                  </Button>
                  : 
                  <Link to={'/package/privilege-list'}>
                    <Button type="primary" className="button-my-package">
                      {t('package_my_package')}
                    </Button>
                  </Link>
                }
                {/* <Link to={'/package/privilege-list'}>
                  <Button type="primary" className="button-my-package">
                    {t('package_my_package')}
                  </Button>
                </Link> */}
              </div>
            </Modal>

            <Modal
              visible={isFalseTermAndConditionModalVisible}
              width={300}
              footer={null}
              closable={false}
              centered
            >
              <div className={'modal-success-term-and-condition-body package-font-family-giovanni-and-sukhumvit'}>
                <div className={'modal-package-icon'}><CloseCircleOutlined /></div>
                <Title level={3} className={'modal-packge-title'}>
                  {t('failed_label')}
                </Title>
                <div className='modal-package-detail'>{t('package_modal_failed_detail')}</div>
                <Button type="primary" className="button-my-package" onClick={this.closeLiff}>
                  {t('done_label')}
                </Button>
              </div>
            </Modal>

            <div className={'section-header'}>
              <div className={'section-header-title'}>
                {t('home_title_my_privilege')}
              </div>
            </div>
            <CategoryHome
              iconMode={true}
              data={this.props.category}
              onClickItem={category => this.selectCategory(category)}
            />
            {this.state.upcomingBooking
              ? [
                <div className={'section-header'}>
                  <div className={'section-header-title'}>
                    {t('home_title_upcoming_booking')}
                  </div>
                  <div className={'section-header-more'}>
                    <Link to="/booking/list/">
                      {t('home_view_all_label')}
                    </Link>
                  </div>
                </div>,
                <UpcomingBox booking={this.state.upcomingBooking} />,
              ]
              : null}
            {this.state.favorites.length !== 0
              ? [
                <div className={'section-header'}>
                  <div className={'section-header-title'}>
                    {t('home_title_favorite')}
                  </div>
                  <div className={'section-header-more'}>
                    <Link
                      button_id="Favourite_ViewAll_btn"
                      to="/favorite/"
                      onClick={setGaViewAll('view_all_favourite', {
                        category: 'view_all_favourite',
                      })}
                    >
                      {t('home_view_all_label')}
                    </Link>
                  </div>
                </div>,
                <FavoriteHome data={this.state.favorites} />,
              ]
              : [
                <div className={'section-header'}>
                  <div
                    className={'section-header-title'}
                    dangerouslySetInnerHTML={{
                      __html: t('home_title_no_favorite'),
                    }}
                  />
                </div>,
                <div className={'no-favourite'}> </div>,
              ]}
            {this.state.news.length !== 0
              ? [
                <div className={'section-header'}>
                  <div className={'section-header-title'}>
                    {t('home_title_news')}
                  </div>
                  <div className={'section-header-more'}>
                    <Link
                      button_id="News_ViewAll_btn"
                      to="/activities/"
                      onClick={setGaViewAll('view_all_news', {
                        category: 'view_all_news',
                      })}
                    >
                      {t('home_view_all_label')}
                    </Link>
                  </div>
                </div>,
                <NewsHome data={this.state.news} />,
              ]
              : null}
            {this.state.seasonalPrivileges.length !== 0
              ? [
                <div className={'section-header'}>
                  <div className={'section-header-title'}>
                    {t('home_title_privileges')}
                  </div>
                </div>,
                <PrivilegeList data={this.state.seasonalPrivileges} />,
                <div className={'section-header'}>
                  <div className={'section-header-more-center'}>
                    <Link to="/privileges/">{t('home_view_all_label')}</Link>
                  </div>
                </div>,
              ]
              : null}
          </>
        }
      </Layout>
    )
  }
}

const mapStateToProps = ({ user, category }) => {
  return {
    token: user.token,
    profileId: user.profileId,
    category,
  }
}

const mapDispatchToProps = dispatch => ({
  openLoading(isLoading) {
    dispatch(openLoading(isLoading))
  },
  setCategory(category) {
    dispatch(setCategory(category))
  },
  setGroupInfo(group) {
    dispatch(setGroupInfo(group))
  },
})

export default withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(IndexPage)
)
